import script from "./InspecaoSupervisaoEstabelecimentoCabecalhoB.vue?vue&type=script&setup=true&lang=js"
export * from "./InspecaoSupervisaoEstabelecimentoCabecalhoB.vue?vue&type=script&setup=true&lang=js"

import "./InspecaoSupervisaoEstabelecimentoCabecalhoB.vue?vue&type=style&index=0&id=26495fad&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26495fad"]])

export default __exports__